module.exports = "/images/contract-cht-page-6.jpg?37930b910f6e34d1cd5141c73c0d6c8f";